"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.colors = exports.darkTheme = exports.lightTheme = void 0;
var themes_1 = require("./themes");
Object.defineProperty(exports, "lightTheme", { enumerable: true, get: function () { return themes_1.lightTheme; } });
var themes_2 = require("./themes");
Object.defineProperty(exports, "darkTheme", { enumerable: true, get: function () { return themes_2.darkTheme; } });
// DEPRECATED in favor of importing theme objects above
var colors_1 = require("./colors");
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return colors_1.colors; } });
var typography_1 = require("./typography");
Object.defineProperty(exports, "typography", { enumerable: true, get: function () { return typography_1.typography; } });
//# sourceMappingURL=index.js.map